import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NgApexchartsModule } from 'ng-apexcharts';
import { MaterialModule } from 'src/app/material.module';

@Component({
  selector: 'app-lessons-stats',
  standalone: true,
  imports: [MaterialModule, NgApexchartsModule],
  templateUrl: './lessons-stats.component.html',
})
export class LessonsStatsComponent implements OnChanges {
  // { date: string, count: string | number }[]
  @Input() data: any[] = [];
  chartOptions: any = {};
  @Input() periodLabel = '';
  constructor() { this.buildChart(); }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) this.buildChart();
  }

  private buildChart(): void {
    const dates = this.data.map(d => d.date);
    const counts = this.data.map(d => Number(d.count));
    // console.log('dates',dates);
    this.chartOptions = {
      series: [{ name: 'Completed', data: counts }],
      chart: { type: 'bar', height: 250, toolbar: { show: false } },
      plotOptions: { bar: { borderRadius: 4, columnWidth: '55%' } },
      colors: ['#4caf50'],
      dataLabels: { enabled: false },
      xaxis: { type: 'datetime', categories: dates, labels: { format: 'dd MMM' } },
      yaxis: { min: 0, labels: { formatter: (v: number) => Math.floor(v).toString() } },
      grid: { borderColor: '#f0f0f0', strokeDashArray: 4 },
      tooltip: { x: { format: 'dd MMM yyyy' } },
    };
  }
}
